<template>
  <div class="checkout-step">
    <SfHeading
      v-if="!!title"
      :title="`${currentStep + 1}. ` + $t(`${title}`)"
      :level="2"
    />
    <slot></slot>
    <div class="actions">
      <SfButton
        v-if="!!currentStep"
        class="action sf-button--outline"
        @click="$emit('click:back')"
      >
        {{ $t('Back') }}
      </SfButton>
      <SfButton
        v-if="!isFinalStep"
        class="action"
        :disabled="!allowNextStep"
        @click="$emit('click:next')"
      >
        {{ $t('Next') }}
      </SfButton>
      <SfButton
        v-if="isFinalStep"
        :disabled="!allowPlaceOrder"
        class="action"
        @click="$emit('click:confirm')"
      >
        {{ $t('Place order') }}
      </SfButton>
    </div>
  </div>
</template>

<script>
import {
  SfHeading,
  SfButton,
} from '@storefront-ui/vue';

export default {
  name: 'Step',
  components: {
    SfHeading,
    SfButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    allowNextStep: {
      type: Boolean,
      default: false,
    },
    allowPlaceOrder: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    isFinalStep: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";
.sf-heading {
  @include flexbox-mobile {
    margin-bottom: var(--spacer-sm);
  }

  @include flexbox-tablet {
    margin-bottom: var(--spacer-base);
  }

  @include flexbox-desktop {
    --heading-text-align: left;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin: var(--spacer-sm) 0;

  div:first-child .sf-button {
    @include flexbox-mobile {
      margin-bottom: var(--spacer-xs);
    }
  }
}

.action+.action {
  margin-left: 10px;
}
</style>
